module.exports = __webpack_public_path__ + "img/bjsdfgzc_position_img.e55442bc.png";